const stMob = {
  containHeader: {
    display: 'flex',
    flexDirection: 'row',

    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    marginBottom: '15px',
  },
  containButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    marginBottom: '10px',
  },
  bttFiltro: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    margin: '0px 2px',
    padding: '10px',
    borderRadius: '15px',
    backgroundColor: '#f0f0f0',
    color: 'black',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: '#f0f0f0',
      boxShadow: 'none',
    },
  },
  textBtt: {
    fontSize: '16px',
  },
  bttFiltroSel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    margin: '0px 2px',
    padding: '10px',
    borderRadius: '15px',
    backgroundColor: '#ffd4c7 !important',
    boxShadow: 'none !important',

    '&:hover': {
      backgroundColor: '#ffd4c7 !important',
      boxShadow: 'none !important',
    },
  },

  textSel: {
    fontSize: '16px',

    color: '#ff7043',
  },

  containFiltro: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    margin: '0px 4px',
    padding: '10px',
    borderRadius: '15px',
    backgroundColor: '#f0f0f0',
    color: 'black',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },

  containLabelFiltro: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
  },
  titleFiltro: {
    width: '100%',
    textAlign: 'left',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  valueFiltro: {
    width: '100%',
    textAlign: 'left',
    fontSize: '16px',
    color: '#ff7043',
    fontWeight: 'bold',
  },
  iconFiltro: {
    height: '25px',
    width: '25px',
    color: '#ff7043',
  },
  containModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  containModalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    height: 'auto',
    padding: '20px',
    borderRadius: '15px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
  },
  containTitleModal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    marginBottom: '15px',
  },
  titleModal: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  iconClose: {
    height: '30px',
    width: '30px',
    marginLeft: '35px',
    color: '#ff7043',
  },
  containListButtons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
  },
  containSelect: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '90%',
    height: 'auto',
    margin: '5px 0px',
    padding: '5px',
    color: 'black',
    boxShadow: 'none',
  },
  textButton: {
    fontSize: '16px',
  },
  iconCircle: {
    height: '25px',
    width: '25px',
    color: 'gray',
    marginRight: '10px',
  },
  iconCircleSel: {
    height: '25px',
    width: '25px',
    color: '#ff7043',
    marginRight: '10px',
  },
  containListItens: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    marginBottom: '56px',
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',

    /* Esconde a barra de rolagem visualmente no mobile */
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  containSearchAlert: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80%',
    height: '100%',
    margin: '20px 0px',
  },
}

const stDesk = {
  containAgendaUser: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '98%',
    width: 'calc(100% - 30px)',
    maxWidth: '1200px',
    padding: '15px',
    backgroundColor: 'white',
    border: '2px solid #ff7043',
    borderRadius: '15px',
    overflow: 'hidden',
  },
  containTitle: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
  },
  iconBack: {
    position: 'absolute',
    left: '0px',
    height: '30px',
    width: '30px',
    color: '#ff7043',
    cursor: 'pointer',
  },
  titlePage: {
    width: '100%',
    textAlign: 'center',
    fontSize: '22px',
    fontWeight: 'bold',
  },
  containAgenda: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    maxWidth: '600px',
  },
  containListItens: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: 'calc(100% - 56px)' /* Ajustar para que o conteúdo não saia do container pai */,
    overflowY: 'auto',
    marginBottom: '15px' /* Remover margem inferior que estava empurrando o conteúdo */,
  },
}

export { stDesk, stMob }
